export default __webpack_public_path__ + "static/media/820.9c2a4b47.png";